"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const BlockButton_1 = __importDefault(require("../Utilities/BlockButton"));
class CarouselControl extends react_1.PureComponent {
    render() {
        const { disabled, onClick, direction, large, hintText } = this.props;
        return (react_1.default.createElement(BlockButton_1.default, { className: "carousel-control", style: disabled ? { visibility: 'hidden' } : {}, onClick: !disabled ? onClick : undefined },
            react_1.default.createElement("i", { className: `fa${large ? ' fa-lg' : ''} fa-angle-${direction}`, "aria-hidden": "true" }),
            react_1.default.createElement("span", { className: "sr-only" }, hintText)));
    }
}
exports.default = CarouselControl;
CarouselControl.propTypes = {
    disabled: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
    direction: prop_types_1.default.oneOf(['up', 'down', 'left', 'right']),
    large: prop_types_1.default.bool,
    hintText: prop_types_1.default.string,
};
